<template>
  <div class="__picture">
    <img :src="url" :width="width" class="__image">
    <div v-if="desc.length > 1" class="desc">{{desc}}</div>
  </div>
</template>

<script>
  export default {
    name: "StaticImage",
    props: {
      url: {
        type: String,
      },
      width: {
        type: String,
        default: "600"
      },
      desc: {
        type: String,
        default: ' '
      }
    },
  }
</script>

<style lang="scss" scoped>
.__picture {
  margin: 30px;

  .__image {
    border-radius: 30px;
    box-shadow: 3px 3px 6px #ddd;
  }

  .desc {
    color: #b9b9b9;
    font-size: 12px;
    margin: 10px 0px 0px 25px;
  }

}
</style>